import React from 'react';
import { cn } from '../lib/utils';

/**
 * StatusBotIcon component that renders the StatusBot logo
 * Compatible with Tailwind CSS text color and size classes (e.g., text-blue-500, w-8 h-8)
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS class name
 */
const StatusBotIcon = ({ className = 'w-8 h-8' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 30 30" 
      className={cn('w-8 h-8', className)}
      fill="currentColor"
    >
      <path d="M18.46,11.77c-1.37,0-2.48,1.11-2.48,2.48s1.11,2.48,2.48,2.48,2.48-1.11,2.48-2.48-1.11-2.48-2.48-2.48h0Z"/>
      <path d="M10.57,11.77c-1.37,0-2.48,1.11-2.48,2.48s1.11,2.48,2.48,2.48,2.48-1.11,2.48-2.48-1.11-2.48-2.48-2.48h0Z"/>
      <path d="M17.28,2.71c1.66.09,3.25.58,4.67,1.41l-1.19,1.19-.69.69c-.1.09-.18.19-.27.3-.76.99-.7,2.39.15,3.32.08.09.17.17.26.25,1.18,1.25,2.04,2.77,2.48,4.42.23.87.35,1.76.35,2.67,0,5.68-4.62,10.3-10.3,10.3-1.86,0-3.64-.49-5.22-1.42l1.9-1.9.02-.02c.48-.48.76-1.14.76-1.82s-.27-1.34-.76-1.82c-.44-.44-.84-.93-1.2-1.45-.67-.97-1.16-2.03-1.47-3.16-.04-.15-.08-.29-.11-.43-.16-.73-.25-1.49-.25-2.24,0-5.48,4.27-9.98,9.73-10.28h1.14M17.35.14h-1.27C9.26.47,3.84,6.1,3.84,12.99c0,.96.11,1.9.31,2.8.04.18.09.36.13.54.38,1.43,1.01,2.77,1.83,3.96.45.65.95,1.25,1.5,1.8l-.02.02-2.55,2.55c-.8.8-.68,2.12.24,2.78,2.1,1.5,4.68,2.38,7.46,2.38,7.11,0,12.87-5.76,12.87-12.87,0-1.15-.15-2.27-.44-3.33-.59-2.21-1.76-4.19-3.33-5.76h-.01s0,.01,0,.01h0s0,0,0,0c0,0,0,0,0,0h.01s0-.01,0-.01l.72-.72,1.85-1.85c.79-.79.69-2.11-.22-2.77-1.95-1.4-4.31-2.27-6.86-2.39h0Z"/>
    </svg>
  );
};

export default StatusBotIcon;
